import React, { useState } from 'react';
import classNames from 'classnames';

import { LeadForm } from '../../LeadForm/LeadForm';
import styles from './ClaimBanner.module.scss';
import { GTM_ACTION, GTM_CLASS } from '../../../lib/constant';

const ClaimBanner = () => {
  const [popup, setPopup] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const PopupClaimForm = () => {
    return (
      <>
        <button
          className={styles.claimBanner__leadform__box__closeBtn}
          onClick={() => setPopup(false)}
        >
          &#215;
        </button>
        <div className={styles.claimBanner__leadform__box__head}>
          <span>
            <div className={styles.claimBanner__leadform__box__head__title}>Halo Teman Lifepal</div>
            <div className={styles.claimBanner__leadform__box__head__subtitle}>
              Kami Siap Membantu Kamu
            </div>
          </span>
          <span>
            {' '}
            <img
              src="/media/static/images/claim-help-icon.png"
              alt="Klaim Asuransi"
              loading="lazy"
            />{' '}
          </span>
        </div>
        <LeadForm
          category="claim"
          background="light"
          gtmAction={GTM_ACTION.CLAIM}
          submittedClaimLeadform={() => setSubmitted(true)}
        />
      </>
    );
  };

  const ThankYouMessage = () => {
    return (
      <div className={styles.claimBanner__thank}>
        <button className={styles.claimBanner__thank__closeBtn} onClick={() => setPopup(false)}>
          &#215;
        </button>
        <img
          src="/media/static/images/mediaLeadSubmit.svg"
          alt="Klaim thank you"
          width={120}
          height={120}
        />
        <div className={styles.claimBanner__thank__title}>Terima kasih Telah Mengisi Form</div>
        <div className={styles.claimBanner__thank__subtitle}>
          Anda akan dihubungi pihak Lifepal untuk informasi lebih lanjut
        </div>
        <button
          className={styles.claimBanner__thank__submitBtn}
          onClick={() => setSubmitted(false)}
        >
          Isi Form Kembali
        </button>
      </div>
    );
  };

  const PopupClaim = () => {
    return (
      <div className={styles.claimBanner__leadform__background}>
        <div className={styles.claimBanner__leadform__box}>
          {submitted ? <ThankYouMessage /> : <PopupClaimForm />}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.claimBanner}>
      {popup && <PopupClaim />}
      <div className={styles.claimBanner__title}>Bantuan Klaim Asuransi Mudah</div>
      <div className={styles.claimBanner__subtitle}>
        Silakan klik tombol dibawah ini untuk bantuan dalam klaim asuransi anda.
      </div>
      <button
        className={classNames(styles.claimBanner__claimBtn, GTM_CLASS.OPEN_LEADFORM_CLAIM)}
        onClick={() => setPopup(true)}
      >
        Klaim sekarang
      </button>
    </div>
  );
};

export default ClaimBanner;
